import classes from './styles.module.scss';
import { useWindowDimensions } from '@/hook';
import { DimensionsTargets } from '@/hook/use-window-width.hook';

interface IBlinkingSkeletonProps {
    width?: string;
    height?: string;
    minHeight?: string;
}
const BlinkingSkeleton = ({
    width = '100%',
    height = '100%',
    minHeight = '',
}: IBlinkingSkeletonProps) => {
    const { IS_DESKTOP } = useWindowDimensions(DimensionsTargets.MOBILE);
    return (
        <div
            className={classes.wrapper}
            style={{
                width,
                height,
                minHeight: minHeight?.length
                    ? minHeight
                    : IS_DESKTOP
                    ? '80cw'
                    : 'calc(40vw)',
            }}
        />
    );
};

export default BlinkingSkeleton;
